export { CouponDetailModal } from './coupon-detail-modal';
export type { CouponDetailModalProps } from './coupon-detail-modal.types';
